
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DistributionChannelDetailsResponse, DistributionChannelsService } from '@src/app/shared/backend/clients';
import { ConfirmationService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { PermissionService } from '@src/app/shared/services/permission.service';
import { Actions } from '@src/app/shared/backend/auth/Action';
import { DialogReasonComponent } from '@src/app/shared/components/dialog-reason/dialog-reason.component';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-view-distribution-channel',
    templateUrl: './view-distribution-channel.component.html',
    styleUrl: './view-distribution-channel.component.scss',
    host: {
        class: 'app-view-distribution-channel'
    },
    providers: [ConfirmationService],
    standalone: false
})
export class ViewDistributionChannelComponent  extends BaseViewComponent implements OnInit {

  @ViewChild('dialog') dialog: DialogReasonComponent | undefined;

  delete: boolean = false;
  allowModifyDistributionChannel: boolean = false;
  distributionChannelId: number = 0;
  distributionChannel: DistributionChannelDetailsResponse = {
    id: 0,
    name: '',
    code: ''
  };

  constructor(
    private permissionService: PermissionService,
    private router: Router,
    private route: ActivatedRoute,
    private distributionChannelsService: DistributionChannelsService) {
      super();
  }

  override async setData(data: any) {

    if (!data) {
      return;
    }
    this.distributionChannelId = data;
    await this.get();

  }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    this.route.params.subscribe(async params => {
      this.distributionChannelId = params['distributionChannelId'];
      await this.get();
    })

  }

  override async get() {
    try {
      this.distributionChannel = await firstValueFrom(this.distributionChannelsService.apiDistributionChannelsDetailsIdGet(this.distributionChannelId));

      this.delete = await this.permissionService.hasActionPermissions(Actions.delete);
      this.allowModifyDistributionChannel = await this.permissionService.hasActionPermissions(Actions.modify_distributionchannels);

    } catch (error) {
      console.log('Error fetching distributionChannel data:', error);
    }
  }

  goToEditDistributionChannel() {
    this.router.navigate([`/distribution-channels/${this.distributionChannelId}/edit`]);
  }

  async showDeleteDialog(): Promise<void> {
    const deleteCheckResponses = await firstValueFrom(this.distributionChannelsService.apiDistributionChannelsDeleteCheckBatchPost([this.distributionChannelId]));

    this.dialog?.show(deleteCheckResponses);
  }

  async deleteDistributionChannel(doDelete: boolean): Promise<void> {
    if (doDelete) {
      await firstValueFrom(this.distributionChannelsService.apiDistributionChannelsDeleteIdDelete(this.distributionChannelId));
      this.router.navigate([`/distribution-channels`]);
    }
  }
}
